import { FiHome, FiChevronRight } from "react-icons/fi";
import React from "react";
import { useNavigate } from "react-router-dom";

const DetailsPageNavigation = ({ list = [] }) => {
  const navigate = useNavigate();

  const handleNavigation = (index) => {
    if (index === list.length - 1) {
      window.location.reload();
      return;
    }

    // Fix navigation logic
    // If we're at item 0, go to index 0
    // If we're at item 1, go to index 1
    // This will properly navigate back in the path
    const currentItem = list[index];
    if (typeof currentItem === "object" && currentItem.path) {
      navigate(currentItem.path, {
        replace: true,
        state: { from: "breadcrumb" },
      });
    } else {
      navigate(-1 * (list.length - 1 - index), {
        replace: true,
        state: { from: "breadcrumb" },
      });
    }
  };

  return (
    <div className="d-flex align-items-center gap-0 mb-4 text-muted mt-0 pt-0">
      <div
        className="text-decoration-none text-muted hover-primary d-flex align-items-center cursor-pointer"
        onClick={() => navigate("/organisation")}
        style={{ cursor: "pointer" }}
      >
        <FiHome style={{ fontSize: "0.75rem" }} />
        <span className="ms-1" style={{ fontSize: "0.75rem" }}>
          Home
        </span>
      </div>

      {list.map((item, index) => (
        <div key={index} className="d-flex align-items-center">
          <FiChevronRight
            style={{
              fontSize: "0.65rem",
              opacity: 0.75,
              marginLeft: "4px",
              marginRight: "4px",
            }}
          />
          <div
            onClick={() => handleNavigation(index)}
            className="text-decoration-none hover-primary fw-medium d-flex align-items-center"
            style={{
              fontSize: "0.75rem",
              color:
                index === list.length - 1 ? "var(--bs-primary)" : "inherit",
              cursor: "pointer",
            }}
          >
            {typeof item === "string" ? item : item.label}
          </div>
        </div>
      ))}
    </div>
  );
};

export default DetailsPageNavigation;
